import React from "react";
import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Image from "../../../../image/image";
import EditButton from "../../../../../backend/edit-button";
import LazyLoad from "react-lazyload";
import { encodeUrl } from "../../../../../lib/encode-url";
import CustomHyphenation from "@default/general-components/custom-hyphenation";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import classNames from "classnames";
import SimpleDesignLinkButton from "@default/js/simple-design/simple-design-link-button";

const Content = ({ item }) => {
  const mainSettings = useSelector(
    (reduxStore) => reduxStore.appStore.mainSettings
  );
  const isMobile = useSelector((reduxStore) => reduxStore.appStore.isMobile);
  const { simpleDesign } = useAccessibilityContext();

  return (
    <div className={classNames({
      'row': isMobile || simpleDesign
    })}>
      {/* Image only needed for: Speaker Overview and mobile */}
      {item.fieldImage && (isMobile || simpleDesign) && (
        <div className={classNames({
          'image': true,
          'col-6': isMobile,
          'col-lg-3': simpleDesign,
        })}>
          <LazyLoad offset={1000}>
            <Image
              data={item.fieldImage.fieldMediaImage}
              credit={item.fieldImage.fieldCredits}
              nodeTitle={item.title}
            />
          </LazyLoad>
        </div>
      )}
      <div className={`infos ${(isMobile || simpleDesign) ? "" : ""}`}
           className={classNames({
             'infos': true,
             'col-6': isMobile,
             'col-12': !isMobile,
             'col-lg-9': simpleDesign,
           })}
        >
        <div className="row">
          <div className="col-12 info-col">
            {!!item.fieldEvents?.length &&
              item.fieldEvents[0].fieldVenue?.title && (
                <div className="meta-infos">
                  {mainSettings?.fieldReleaseState === "all" && (
                    <div className="location">
                      {item.fieldEvents[0].fieldVenue.title}
                    </div>
                  )}
                </div>
              )}
            <h2
              className={classNames({
              'name': true,
              'headline-s': simpleDesign,
              'headline-m': !simpleDesign
              })}
            >
              <CustomHyphenation length={8}>{item.title}</CustomHyphenation>
            </h2>
            <SimpleDesignLinkButton tabIndex={-1}/>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeaserScrollOverviewContent = ({ item, index }) => {
  const adminApp = useSelector((reduxStore) => reduxStore.appStore.adminApp);
  const isMobile = useSelector((reduxStore) => reduxStore.appStore.isMobile);
  const { simpleDesign } = useAccessibilityContext();

  const dispatch = useDispatch(),
    location = useLocation();

  return (
    <article
      className={classNames({
        'node node-teaser teaser-scroll-overview scroll-overview-listener': true,
        'col-12': simpleDesign,
        'row': isMobile && !simpleDesign
      })}
      data-index={index}
      id={encodeUrl(`${item.title}-${item.id}`)}
      data-to-scrollspy-id={encodeUrl(`${item.title}-${item.id}`)}
      data-teaser-index={index}
    >
      <EditButton
        adminApp={adminApp}
        entityId={item.id}
        destinationRoute={location.pathname}
      />
      <Link className="flex-wrap" to={item?.uri?.path} forceSameTab={true}>
        <Content item={item} />
      </Link>
    </article>
  );
};

export const teaserActPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  clickBehaviour: PropTypes.bool.required,
  path: PropTypes.shape({
    alias: PropTypes.string,
  }),
  url: PropTypes.shape({
    path: PropTypes.string,
  }),
  fieldTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  fieldImage: PropTypes.shape({
    fieldMediaImage: PropTypes.shape({
      alt: PropTypes.string,
      title: PropTypes.string,
      style: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
});

TeaserScrollOverviewContent.propTypes = {
  item: teaserActPropTypes,
};

export default TeaserScrollOverviewContent;
